module.exports = __webpack_public_path__ + "static/img/integra_logo.5935a45.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo/integra_logo.png
// module id = 169
// module chunks = 31